import PostList from '../components/PostList';
import Layout from '../components/Layout';
import './css/Home.css';

const Home = () => {
    return (
        <div className='home'>
            <Layout>
                <PostList />
            </Layout>
        </div>
    );
};

export default Home;
